import { Store } from '../redux/store';
import { refreshTokenSuccess } from '../redux/reducers/user';
import { axiosPublic } from './axiosInstances';

/**
 * Renueva sesión: envía refreshToken en body si existe (cross-origin),
 * o intenta solo con cookie (localhost / mismo dominio).
 */
export async function refreshSession() {
    const { refreshToken } = Store.getState().user;

    const response = refreshToken
        ? await axiosPublic.post('/auth/refresh-token', { refreshToken })
        : await axiosPublic.get('/auth/refresh-token');

    Store.dispatch(refreshTokenSuccess(response.data));
    return response;
}

export function getAccessToken() {
    return Store.getState().user.accessToken;
}
